define("shared/components/shared/upgrade/plan-highlight", ["exports", "@ember/component", "@ember/template-factory", "@ember/component/template-only"], function (_exports, _component, _templateFactory, _templateOnly) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/component/template-only"eaimeta@70e063a35619d71f

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <p class="tPF--plan__metaRow {{if @isFeatureList 'u--text--sm u--m__b__xs u--text--hair'}}">
    {{#unless @hideIcon}}
      {{#if @iconName}}
        {{svg-jar @iconName class="o--icon--sm tPF--plan__icon tPF--plan__icon--light"}}
      {{else}}
        {{svg-jar "check" class="o--icon--sm tPF--plan__icon"}}
      {{/if}}
    {{/unless}}
    <span>{{html-safe @description}}</span>
  </p>
  */
  {
    "id": "tj6yQ0mT",
    "block": "[[[10,2],[15,0,[29,[\"tPF--plan__metaRow \",[52,[30,1],\"u--text--sm u--m__b__xs u--text--hair\"]]]],[12],[1,\"\\n\"],[41,[51,[30,2]],[[[41,[30,3],[[[1,\"      \"],[1,[28,[35,2],[[30,3]],[[\"class\"],[\"o--icon--sm tPF--plan__icon tPF--plan__icon--light\"]]]],[1,\"\\n\"]],[]],[[[1,\"      \"],[1,[28,[35,2],[\"check\"],[[\"class\"],[\"o--icon--sm tPF--plan__icon\"]]]],[1,\"\\n\"]],[]]]],[]],null],[1,\"  \"],[10,1],[12],[1,[28,[35,3],[[30,4]],null]],[13],[1,\"\\n\"],[13]],[\"@isFeatureList\",\"@hideIcon\",\"@iconName\",\"@description\"],false,[\"if\",\"unless\",\"svg-jar\",\"html-safe\"]]",
    "moduleName": "shared/components/shared/upgrade/plan-highlight.hbs",
    "isStrictMode": false
  });

  var _default = (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, (0, _templateOnly.default)());

  _exports.default = _default;
});